import { useEffect, useRef, useState } from "react";

function useDebounce<T>(value: T, delay?: number): T;
function useDebounce<T>(value: T, delay: number, validationFn: (val: T) => boolean): { debouncedValue: T; isValid: boolean; isValidating: boolean };
function useDebounce<T>(value: T, delay: number = 1000, validationFn?: (val: T) => boolean) {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);
    const [isValid, setIsValid] = useState(true);
    const [isValidating, setIsValidating] = useState(false);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (validationFn && (value as unknown as string) !== "") {
            setIsValidating(true);
        }

        const timer = window.setTimeout(() => {
            setDebouncedValue(value);
            if (validationFn) {
                setIsValid((value as unknown as string) === "" || validationFn(value));
                setIsValidating(false);
            }
        }, delay);

        return () => window.clearTimeout(timer);
    }, [value, delay]);

    if (!validationFn) return debouncedValue;
    return { debouncedValue, isValid, isValidating };
}

export default useDebounce;
